import { GreyScale } from '@medly-components/theme';

const grey: GreyScale = {
    50: '#F5F5F5',
    100: '#F7F8F9',
    200: '#EFF2F4',
    300: '#DFE4E9',
    400: '#C7D0D8',
    500: '#B0BCC8',
    600: '#98A7B7',
    700: '#607890',
    800: '#546A7F',
    900: '#435465'
};

export default grey;
